<template>
  <!--
    Permanent "this is not production" marker for the dev environment.

    It only renders when the bundle was built with VUE_APP_SANDBOX_BADGE, which
    is passed exclusively by docker-compose.dev.yml. vue-cli inlines only the
    VUE_APP_* variables that exist at build time, so a production build compiles
    isSandbox() down to

        Boolean({NODE_ENV:"production",BASE_URL:"/"}.VUE_APP_SANDBOX_BADGE)

    - an object literal with no such key, i.e. a hard false. The component does
    still ship in the production bundle (a few hundred dead bytes); what is
    guaranteed is that it can never RENDER there, under any runtime condition.

    pointer-events-none: always visible, but incapable of intercepting a click,
    so it can never get in the way of the screens the client is reviewing.
    z-[10000]: above every other layer in the app (the highest in use is 9999),
    so a modal or overlay cannot hide the fact that this is a test environment.
  -->
  <div
    v-if="isSandbox"
    role="note"
    aria-label="Sandbox environment - test data"
    class="fixed bottom-4 left-4 z-[10000] pointer-events-none select-none
           flex items-center gap-2 rounded-full
           bg-empire-dark/95 text-white shadow-lg ring-1 ring-white/25
           px-3 py-1.5 text-[11px] font-bold uppercase tracking-[0.15em]
           sm:px-4 sm:py-2 sm:text-xs"
  >
    <span class="h-2 w-2 rounded-full bg-orange-400" aria-hidden="true"></span>
    Sandbox
  </div>
</template>

<script>
export default {
  name: 'SandboxBadge',
  computed: {
    isSandbox() {
      // vue-cli inlines only the VUE_APP_* variables present at build time, so
      // on a production build this reads as undefined -> false.
      return Boolean(process.env.VUE_APP_SANDBOX_BADGE)
    }
  }
}
</script>
